import { render } from "./Initial.vue?vue&type=template&id=7f472a16&scoped=true"
import script from "./Initial.vue?vue&type=script&lang=js"
export * from "./Initial.vue?vue&type=script&lang=js"

import "./Initial.vue?vue&type=style&index=0&id=7f472a16&scoped=true&lang=css"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f472a16"]])

export default __exports__